




































































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppArchiveCard from '~/components/partials/App/AppArchiveCard.vue';
import AppArticleCard from '~/components/partials/App/AppArticleCard.vue';
import AppProducerCard from '~/components/partials/App/AppProducerCard.vue';
import AppRelatedContentsLayout from '~/components/partials/App/AppRelatedContentsLayout.vue';
import ContentRelatedEvent from '~/components/partials/Content/ContentRelatedEvent.vue';
import { ArticleCard, ArticleCategory, EditorProfile, RelatedProducerArticle } from '~/types/modules/contents';
import { EventSummaryResponseSchema, EventCardTags } from '~/types/modules/event';

export default defineComponent({
  components: {
    AppRelatedContentsLayout,
    AppArchiveCard,
    AppArticleCard,
    AppProducerCard,
    ContentRelatedEvent,
  },
  props: {
    specialFeatures: {
      type: Array as PropType<ArticleCard[]>,
      default: () => [],
    },
    magazines: {
      type: Array as PropType<ArticleCard[]>,
      default: () => [],
    },
    magazinesCategories: {
      type: Array as PropType<ArticleCategory[]>,
      default: () => [],
    },
    magazinesAuthors: {
      type: Array as PropType<EditorProfile[]>,
      default: () => [],
    },
    producers: {
      type: Array as PropType<RelatedProducerArticle[]>,
      default: () => [],
    },
    events: {
      type: Array as PropType<EventSummaryResponseSchema[]>,
      default: () => [],
    },
    eventsTags: {
      type: Array as PropType<EventCardTags[]>,
      default: () => [],
    },
  },
  setup(props) {
    // 各関連するイベントの全タグ名称を取得
    const getEventTags = (id: number) => {
      const searchTags = props.eventsTags.find((tag) => tag.id === id);
      return searchTags?.tags || [];
    };

    return {
      getEventTags,
    };
  },
});
